// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.login-transition {
  --transition-blue: #38bdf8;
  --transition-cyan: #22d3ee;
  position: fixed;
  inset: 0;
  z-index: 9999;
  display: grid;
  place-items: center;
  min-height: 100vh;
  overflow: hidden;
  color: #f8fafc;
  background:
    radial-gradient(circle at 50% 42%, rgba(14, 116, 144, .22), transparent 34%),
    linear-gradient(145deg, #020617 0%, #07152a 54%, #020617 100%);
  font-family: inherit;
}

.transition-grid {
  position: absolute;
  inset: -35%;
  opacity: .16;
  background-image:
    linear-gradient(rgba(56, 189, 248, .28) 1px, transparent 1px),
    linear-gradient(90deg, rgba(56, 189, 248, .28) 1px, transparent 1px);
  background-size: 54px 54px;
  transform: perspective(500px) rotateX(62deg) translateY(36%);
  animation: transition-grid-move 3.2s linear forwards;
}

.transition-glow {
  position: absolute;
  width: 32vw;
  height: 32vw;
  border-radius: 50%;
  filter: blur(100px);
  opacity: .17;
}

.transition-glow-one { top: -18%; left: -10%; background: #2563eb; }
.transition-glow-two { right: -12%; bottom: -20%; background: #06b6d4; }

.transition-stage {
  position: relative;
  z-index: 1;
  width: min(86vw, 560px);
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  animation: transition-stage-in .7s cubic-bezier(.2, .8, .2, 1) both;
}

.transition-orbit {
  position: relative;
  width: 260px;
  height: 260px;
  display: grid;
  place-items: center;
  margin-bottom: 30px;
}

.orbit-ring, .orbit-pulse {
  position: absolute;
  border-radius: 50%;
}

.orbit-ring {
  inset: 12px;
  border: 1px solid rgba(56, 189, 248, .24);
  animation: transition-spin 5s linear infinite;
}

.orbit-ring::before, .orbit-ring::after {
  content: "";
  position: absolute;
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: var(--transition-cyan);
  box-shadow: 0 0 18px 4px rgba(34, 211, 238, .75);
}

.orbit-ring::before { top: 19%; left: 8%; }
.orbit-ring::after { right: 3%; bottom: 31%; }
.orbit-ring-two { inset: 34px; border-style: dashed; animation-direction: reverse; animation-duration: 3.4s; }
.orbit-ring-three { inset: 54px; animation-duration: 2.4s; }
.orbit-pulse {
  inset: 68px;
  border: 1px solid rgba(34, 211, 238, .5);
  animation: transition-pulse 1.5s ease-out infinite;
}

.orbit-satellite {
  position: absolute;
  width: 5px;
  height: 5px;
  border-radius: 50%;
  background: #fff;
  box-shadow: 0 0 15px 3px var(--transition-blue);
}

.satellite-one { top: 16px; left: 50%; }
.satellite-two { right: 25px; bottom: 54px; }
.satellite-three { left: 30px; bottom: 62px; }

.transition-core {
  position: relative;
  width: 112px;
  height: 112px;
  display: grid;
  place-items: center;
  overflow: hidden;
  border: 1px solid rgba(125, 211, 252, .7);
  border-radius: 28px;
  background: linear-gradient(145deg, rgba(15, 35, 61, .96), rgba(2, 6, 23, .95));
  box-shadow: 0 0 60px rgba(14, 165, 233, .25), inset 0 0 30px rgba(56, 189, 248, .1);
  transform: rotate(45deg);
  animation: transition-core-float 2s ease-in-out infinite;
}

.transition-core img {
  width: 74px;
  height: 74px;
  object-fit: contain;
  transform: rotate(-45deg);
  filter: drop-shadow(0 0 12px rgba(56, 189, 248, .4));
}

.core-scan {
  position: absolute;
  z-index: 2;
  width: 170%;
  height: 2px;
  background: #a5f3fc;
  box-shadow: 0 0 16px 3px #22d3ee;
  animation: transition-scan 1.35s ease-in-out infinite;
}

.transition-copy { animation: transition-copy-in .6s .35s ease both; }
.transition-eyebrow {
  display: block;
  margin-bottom: 10px;
  color: #67e8f9;
  font-size: 11px;
  font-weight: 800;
  letter-spacing: .34em;
}

.transition-copy h1 {
  margin: 0;
  font-size: clamp(30px, 6vw, 48px);
  line-height: 1.05;
  letter-spacing: -.035em;
}

.transition-copy p {
  margin: 12px 0 0;
  color: #94a3b8;
  font-size: 15px;
}

.transition-progress {
  width: min(100%, 400px);
  margin-top: 38px;
  animation: transition-copy-in .6s .55s ease both;
}

.transition-progress-track {
  height: 3px;
  overflow: hidden;
  border-radius: 99px;
  background: rgba(148, 163, 184, .16);
}

.transition-progress-track span {
  display: block;
  height: 100%;
  border-radius: inherit;
  background: linear-gradient(90deg, #2563eb, #22d3ee, #fff);
  box-shadow: 0 0 15px #22d3ee;
  transition: width .08s linear;
}

.transition-progress-meta {
  display: flex;
  justify-content: space-between;
  margin-top: 10px;
  color: #64748b;
  font-size: 9px;
  font-weight: 800;
  letter-spacing: .2em;
}

.transition-progress-meta strong { color: #bae6fd; font-variant-numeric: tabular-nums; }

@keyframes transition-spin { to { transform: rotate(360deg); } }
@keyframes transition-pulse { 0% { transform: scale(.7); opacity: .8; } 100% { transform: scale(1.65); opacity: 0; } }
@keyframes transition-scan { 0%, 100% { transform: translateY(-75px); opacity: 0; } 20%, 80% { opacity: 1; } 50% { transform: translateY(75px); } }
@keyframes transition-core-float { 50% { transform: rotate(45deg) translate(-5px, -5px); } }
@keyframes transition-grid-move { to { background-position: 0 160px, 160px 0; opacity: .06; } }
@keyframes transition-stage-in { from { opacity: 0; transform: scale(.88); } }
@keyframes transition-copy-in { from { opacity: 0; transform: translateY(14px); } }

@media (max-width: 480px) {
  .transition-orbit { width: 220px; height: 220px; margin-bottom: 22px; }
  .transition-copy h1 { font-size: 32px; }
  .transition-progress { margin-top: 30px; }
}

@media (prefers-reduced-motion: reduce) {
  .login-transition *, .login-transition *::before, .login-transition *::after {
    animation-duration: .01ms !important;
    animation-iteration-count: 1 !important;
  }
}
`, "",{"version":3,"sources":["webpack://./src/auth/LoginTransition.css"],"names":[],"mappings":"AAAA;EACE,0BAA0B;EAC1B,0BAA0B;EAC1B,eAAe;EACf,QAAQ;EACR,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd;;kEAEgE;EAChE,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ;;wEAEsE;EACtE,0BAA0B;EAC1B,4DAA4D;EAC5D,oDAAoD;AACtD;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;AACd;;AAEA,uBAAuB,SAAS,EAAE,UAAU,EAAE,mBAAmB,EAAE;AACnE,uBAAuB,WAAW,EAAE,YAAY,EAAE,mBAAmB,EAAE;;AAEvE;EACE,kBAAkB;EAClB,UAAU;EACV,uBAAuB;EACvB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,mEAAmE;AACrE;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,yCAAyC;EACzC,6CAA6C;AAC/C;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,kCAAkC;EAClC,gDAAgD;AAClD;;AAEA,sBAAsB,QAAQ,EAAE,QAAQ,EAAE;AAC1C,qBAAqB,SAAS,EAAE,WAAW,EAAE;AAC7C,kBAAkB,WAAW,EAAE,oBAAoB,EAAE,4BAA4B,EAAE,wBAAwB,EAAE;AAC7G,oBAAoB,WAAW,EAAE,wBAAwB,EAAE;AAC3D;EACE,WAAW;EACX,wCAAwC;EACxC,kDAAkD;AACpD;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,+CAA+C;AACjD;;AAEA,iBAAiB,SAAS,EAAE,SAAS,EAAE;AACvC,iBAAiB,WAAW,EAAE,YAAY,EAAE;AAC5C,mBAAmB,UAAU,EAAE,YAAY,EAAE;;AAE7C;EACE,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,yCAAyC;EACzC,mBAAmB;EACnB,+EAA+E;EAC/E,mFAAmF;EACnF,wBAAwB;EACxB,wDAAwD;AAC1D;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,yBAAyB;EACzB,oDAAoD;AACtD;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,WAAW;EACX,mBAAmB;EACnB,gCAAgC;EAChC,qDAAqD;AACvD;;AAEA,mBAAmB,gDAAgD,EAAE;AACrE;EACE,cAAc;EACd,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,SAAS;EACT,iCAAiC;EACjC,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,uBAAuB;EACvB,gBAAgB;EAChB,gDAAgD;AAClD;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,oCAAoC;AACtC;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,sBAAsB;EACtB,0DAA0D;EAC1D,4BAA4B;EAC5B,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,gBAAgB;EAChB,cAAc;EACd,cAAc;EACd,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA,mCAAmC,cAAc,EAAE,kCAAkC,EAAE;;AAEvF,6BAA6B,KAAK,yBAAyB,EAAE,EAAE;AAC/D,8BAA8B,KAAK,oBAAoB,EAAE,WAAW,EAAE,EAAE,OAAO,sBAAsB,EAAE,UAAU,EAAE,EAAE;AACrH,6BAA6B,WAAW,4BAA4B,EAAE,UAAU,EAAE,EAAE,WAAW,UAAU,EAAE,EAAE,MAAM,2BAA2B,EAAE,EAAE;AAClJ,mCAAmC,MAAM,8CAA8C,EAAE,EAAE;AAC3F,kCAAkC,KAAK,qCAAqC,EAAE,YAAY,EAAE,EAAE;AAC9F,iCAAiC,OAAO,UAAU,EAAE,qBAAqB,EAAE,EAAE;AAC7E,gCAAgC,OAAO,UAAU,EAAE,2BAA2B,EAAE,EAAE;;AAElF;EACE,oBAAoB,YAAY,EAAE,aAAa,EAAE,mBAAmB,EAAE;EACtE,sBAAsB,eAAe,EAAE;EACvC,uBAAuB,gBAAgB,EAAE;AAC3C;;AAEA;EACE;IACE,oCAAoC;IACpC,uCAAuC;EACzC;AACF","sourcesContent":[".login-transition {\n  --transition-blue: #38bdf8;\n  --transition-cyan: #22d3ee;\n  position: fixed;\n  inset: 0;\n  z-index: 9999;\n  display: grid;\n  place-items: center;\n  min-height: 100vh;\n  overflow: hidden;\n  color: #f8fafc;\n  background:\n    radial-gradient(circle at 50% 42%, rgba(14, 116, 144, .22), transparent 34%),\n    linear-gradient(145deg, #020617 0%, #07152a 54%, #020617 100%);\n  font-family: inherit;\n}\n\n.transition-grid {\n  position: absolute;\n  inset: -35%;\n  opacity: .16;\n  background-image:\n    linear-gradient(rgba(56, 189, 248, .28) 1px, transparent 1px),\n    linear-gradient(90deg, rgba(56, 189, 248, .28) 1px, transparent 1px);\n  background-size: 54px 54px;\n  transform: perspective(500px) rotateX(62deg) translateY(36%);\n  animation: transition-grid-move 3.2s linear forwards;\n}\n\n.transition-glow {\n  position: absolute;\n  width: 32vw;\n  height: 32vw;\n  border-radius: 50%;\n  filter: blur(100px);\n  opacity: .17;\n}\n\n.transition-glow-one { top: -18%; left: -10%; background: #2563eb; }\n.transition-glow-two { right: -12%; bottom: -20%; background: #06b6d4; }\n\n.transition-stage {\n  position: relative;\n  z-index: 1;\n  width: min(86vw, 560px);\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  text-align: center;\n  animation: transition-stage-in .7s cubic-bezier(.2, .8, .2, 1) both;\n}\n\n.transition-orbit {\n  position: relative;\n  width: 260px;\n  height: 260px;\n  display: grid;\n  place-items: center;\n  margin-bottom: 30px;\n}\n\n.orbit-ring, .orbit-pulse {\n  position: absolute;\n  border-radius: 50%;\n}\n\n.orbit-ring {\n  inset: 12px;\n  border: 1px solid rgba(56, 189, 248, .24);\n  animation: transition-spin 5s linear infinite;\n}\n\n.orbit-ring::before, .orbit-ring::after {\n  content: \"\";\n  position: absolute;\n  width: 7px;\n  height: 7px;\n  border-radius: 50%;\n  background: var(--transition-cyan);\n  box-shadow: 0 0 18px 4px rgba(34, 211, 238, .75);\n}\n\n.orbit-ring::before { top: 19%; left: 8%; }\n.orbit-ring::after { right: 3%; bottom: 31%; }\n.orbit-ring-two { inset: 34px; border-style: dashed; animation-direction: reverse; animation-duration: 3.4s; }\n.orbit-ring-three { inset: 54px; animation-duration: 2.4s; }\n.orbit-pulse {\n  inset: 68px;\n  border: 1px solid rgba(34, 211, 238, .5);\n  animation: transition-pulse 1.5s ease-out infinite;\n}\n\n.orbit-satellite {\n  position: absolute;\n  width: 5px;\n  height: 5px;\n  border-radius: 50%;\n  background: #fff;\n  box-shadow: 0 0 15px 3px var(--transition-blue);\n}\n\n.satellite-one { top: 16px; left: 50%; }\n.satellite-two { right: 25px; bottom: 54px; }\n.satellite-three { left: 30px; bottom: 62px; }\n\n.transition-core {\n  position: relative;\n  width: 112px;\n  height: 112px;\n  display: grid;\n  place-items: center;\n  overflow: hidden;\n  border: 1px solid rgba(125, 211, 252, .7);\n  border-radius: 28px;\n  background: linear-gradient(145deg, rgba(15, 35, 61, .96), rgba(2, 6, 23, .95));\n  box-shadow: 0 0 60px rgba(14, 165, 233, .25), inset 0 0 30px rgba(56, 189, 248, .1);\n  transform: rotate(45deg);\n  animation: transition-core-float 2s ease-in-out infinite;\n}\n\n.transition-core img {\n  width: 74px;\n  height: 74px;\n  object-fit: contain;\n  transform: rotate(-45deg);\n  filter: drop-shadow(0 0 12px rgba(56, 189, 248, .4));\n}\n\n.core-scan {\n  position: absolute;\n  z-index: 2;\n  width: 170%;\n  height: 2px;\n  background: #a5f3fc;\n  box-shadow: 0 0 16px 3px #22d3ee;\n  animation: transition-scan 1.35s ease-in-out infinite;\n}\n\n.transition-copy { animation: transition-copy-in .6s .35s ease both; }\n.transition-eyebrow {\n  display: block;\n  margin-bottom: 10px;\n  color: #67e8f9;\n  font-size: 11px;\n  font-weight: 800;\n  letter-spacing: .34em;\n}\n\n.transition-copy h1 {\n  margin: 0;\n  font-size: clamp(30px, 6vw, 48px);\n  line-height: 1.05;\n  letter-spacing: -.035em;\n}\n\n.transition-copy p {\n  margin: 12px 0 0;\n  color: #94a3b8;\n  font-size: 15px;\n}\n\n.transition-progress {\n  width: min(100%, 400px);\n  margin-top: 38px;\n  animation: transition-copy-in .6s .55s ease both;\n}\n\n.transition-progress-track {\n  height: 3px;\n  overflow: hidden;\n  border-radius: 99px;\n  background: rgba(148, 163, 184, .16);\n}\n\n.transition-progress-track span {\n  display: block;\n  height: 100%;\n  border-radius: inherit;\n  background: linear-gradient(90deg, #2563eb, #22d3ee, #fff);\n  box-shadow: 0 0 15px #22d3ee;\n  transition: width .08s linear;\n}\n\n.transition-progress-meta {\n  display: flex;\n  justify-content: space-between;\n  margin-top: 10px;\n  color: #64748b;\n  font-size: 9px;\n  font-weight: 800;\n  letter-spacing: .2em;\n}\n\n.transition-progress-meta strong { color: #bae6fd; font-variant-numeric: tabular-nums; }\n\n@keyframes transition-spin { to { transform: rotate(360deg); } }\n@keyframes transition-pulse { 0% { transform: scale(.7); opacity: .8; } 100% { transform: scale(1.65); opacity: 0; } }\n@keyframes transition-scan { 0%, 100% { transform: translateY(-75px); opacity: 0; } 20%, 80% { opacity: 1; } 50% { transform: translateY(75px); } }\n@keyframes transition-core-float { 50% { transform: rotate(45deg) translate(-5px, -5px); } }\n@keyframes transition-grid-move { to { background-position: 0 160px, 160px 0; opacity: .06; } }\n@keyframes transition-stage-in { from { opacity: 0; transform: scale(.88); } }\n@keyframes transition-copy-in { from { opacity: 0; transform: translateY(14px); } }\n\n@media (max-width: 480px) {\n  .transition-orbit { width: 220px; height: 220px; margin-bottom: 22px; }\n  .transition-copy h1 { font-size: 32px; }\n  .transition-progress { margin-top: 30px; }\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .login-transition *, .login-transition *::before, .login-transition *::after {\n    animation-duration: .01ms !important;\n    animation-iteration-count: 1 !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
